import axios from 'axios'
import { defineStore } from 'pinia'

export const useUserInfoStore = defineStore({
  id: 'userInfo',
  state: () => ({
    user: {}
  }),
  getters: {
    getUserInformation(state) {
      return state.user
    },
    // If you intend to use getProvince, make sure `provinces` exists in your state.
    getProvince(state) {
      return state.provinces
    }
  },
  actions: {
    async callUserInfo() {
      // Ensure the condition includes the subsequent block by using {}

      if (
        localStorage.getItem('auth') ||
        localStorage.getItem("regLog") === "0gfekqqxq4bgbks83fjcyhgz9o631gd"
      ) {
        try {
          const req = await axios.get("https://parsinekala.com/backend/api/customer/");
          // Correctly update the state
          this.user = req.data;
        } catch (e) {
          console.error("Error fetching user info", e);
        }
      }
    }
  }
});
